import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { updateInternalURLsToURIs, addReferrerToSeeHereLinks } from '../../utils/stringOps'

const ShowFullText = ({ fullText }) => {
  if (fullText !== 'not set') {
    return <>
      <div
        className='article-fullText' dangerouslySetInnerHTML={
          {
            __html: addReferrerToSeeHereLinks(updateInternalURLsToURIs(fullText, process.env.APP_BASE_URL))
          }
        }
      />
    </>
  } else {
    return <>
      <div className='article-fullText'><Skeleton count={7} /></div>
    </>
  }
}

export default ShowFullText
